import React, {Component} from "react";
import Screen from "./Screen";
import WorkflowError from "./WorkflowError";
import AuthService from "../../AuthService";
import axios from "axios";
import loader from "../../img/loader.gif";

class Workflow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initData: this.props.initData,
            result: null,
            data: {},
            formData: {}
        }

        this.change = this.change.bind(this);
        this.submit = this.submit.bind(this);
    }

    async componentDidMount() {
        await this.loadData(false);
    }

    async loadData(submit) {
        let data = submit ? this.state.formData : this.state.initData;
        if (submit) {
            this.state.data.workflow.hiddenFields.map(entry => (
                this.state.formData[entry.name] = entry.value
            ));
        }

        await axios.post(
            AuthService.getUrl('/workflow'),
            data,
            AuthService.getAuthHeader()
        ).then(res => {
            this.setState({
                result: res.return,
                data: res.data.data
            });
        }).catch(err => {
            this.setState({errorMessage: 'Sauvegarde impossible'});
        });
    }

    change(e) {
        const target = e.target;
        this.setState(state => {
            const formData = state.formData;
            formData[target.name] = target.value;
            return {formData : formData};
        });
        this.props.onChange(e);
    }

    async submit(e) {
        e.preventDefault();
        await this.loadData(true);
        this.props.onSubmit(this.state.data);
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                <div className="coreWorkflow">
                    <form id={"coreWorkflow-" + this.state.data.workflow.id}
                          method="post"
                          encType="multipart/form-data"
                          style={{width: 'inherit'}}
                          onSubmit={e => this.submit(e)}>
                        <div className="coreWorkflow-header">
                            {this.state.data.workflow.hasErrorLine === true &&
                            <div className="coreWorkflow-error">
                                <WorkflowError workflow={this.state.data.workflow}/>
                            </div>
                            }
                        </div>
                        <div className="coreWorkflow-form">
                            <Screen screen={this.state.data.screen}
                                    onChange={this.change}
                                    externalCall={this.props.externalCall}
                                    primaryKey={this.props.primaryKey}/>
                        </div>
                    </form>
                </div>
            );
        }
    }
}

export default Workflow;
